import React, {PureComponent} from 'react';
import ReactPaginate from 'react-paginate';
import './paginations.scss';

class PaginationApiComponent extends PureComponent {

    handlePageClick = data => {
        this.props.onChangePage(data.selected + 1);
    };

  render() {

    return (
      <div className='pagination__wrap' style={{marginTop: 0}}>
          <ReactPaginate
              previousLabel={'previous'}
              nextLabel={'next'}
              breakLabel={'...'}
              breakClassName={'break-me'}
              pageCount={this.props.totalPages}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={this.handlePageClick}
              containerClassName={'react-pagination-lib'}
              subContainerClassName={'pages pagination'}
              activeClassName={'active'}
          />
          <div className='pagination-info'>
          <span>
            Mostrando de {this.props.pageSize * (this.props.currentPage - 1) + 1 + ' '}
              a {this.props.pageSize * this.props.currentPage > this.props.totalItems ? this.props.totalItems
              : this.props.pageSize * this.props.currentPage} de {this.props.totalItems} entradas
          </span>
          </div>
      </div>
    )
  }
}

export default PaginationApiComponent;


// WEBPACK FOOTER //
// ./src/helpers/PaginationApi.js